// extracted by mini-css-extract-plugin
export default {"menuLink":"Homepage_menuLink__oNa4u"};